<template>
  <div class="widget-button" :style="styleColor">
		<a-button  @click="filterSearch" :style="btnStyle">查询</a-button>
  </div>
</template>
<script>

export default {
  name: "WidgetButton",
  components: {
  },
  props: {
    value: Object,
    ispreview: Boolean
  },
  inject: ["filterSearch"],
  data() {
    return {
      options: {
      },
      dateRange: [],
    };
  },
  computed: {
    transStyle() {
      return this.$objToOne(this.options);
    },
    btnStyle() {
      return {
        color: this.transStyle.color || "#fff",
        background: this.transStyle.background,
        "font-size": this.transStyle.fontSize + "px" || "14px",
      }
    },
    styleColor() {
      return {
        position: this.ispreview ? "absolute" : "static",
        value: this.transStyle.value || [],
        "letter-spacing": this.transStyle.letterSpacing + "em",
        "font-weight": this.transStyle.fontWeight,
        "text-align": this.transStyle.textAlign,
        display:
          this.transStyle.hideLayer == undefined
            ? "block"
            : this.transStyle.hideLayer
            ? "none"
            : "block",
        width: this.transStyle.width + "px",
        height: this.transStyle.height + "px",
        left: this.transStyle.left + "px",
        top: this.transStyle.top + "px",
        right: this.transStyle.right + "px"
      };
    }
  },
  watch: {
    value: {
      handler(val) {
        this.options = val;
      },
      deep: true
    },
  },
  mounted() {
    this.options = this.value;
  },
  methods: {

  }
};
</script>
<style lang="less" scoped>
.widget-button {
  width: 100%;
  height: 100%;
  .ant-btn {
    width: 100%;
    height: 100%;
  }
}
</style>